const FORCE_PASSWORD_CHANGE_KEY = 'FORCE-PASSWORD-CHANGE';
const DAYS_BEFORE_PW_EXPI_KEY = 'DAYS-BEFORE-PASSWORD-EXPIRE';

export const forcePasswordChange = (nbDays: number): void => {
	window.localStorage.setItem(FORCE_PASSWORD_CHANGE_KEY, 'true');
	window.localStorage.setItem(DAYS_BEFORE_PW_EXPI_KEY, nbDays.toString());
};

export const isForcePasswordChange = (): {
	isStoredForcePasswordChange: boolean;
	storedDaysBeforePWExpire: string | null;
} => {
	const storedForcePasswordChange = window.localStorage.getItem(FORCE_PASSWORD_CHANGE_KEY);
	const isStoredForcePasswordChange = storedForcePasswordChange === 'true';
	const storedDaysBeforePWExpire = window.localStorage.getItem(DAYS_BEFORE_PW_EXPI_KEY);
	return { isStoredForcePasswordChange, storedDaysBeforePWExpire };
};

export const removeForcePasswordChange = (): void => {
	window.localStorage.removeItem(FORCE_PASSWORD_CHANGE_KEY);
	window.localStorage.removeItem(DAYS_BEFORE_PW_EXPI_KEY);
};
